import React from 'react'
import warningParam from '../../../../assets/warningParam.svg'
import selectCaution from '../../../../assets/selectCaution.svg'
import LanguageStrings from '../../../../i18n/locales'
import { Typography } from '@mui/material'

const WarningString = LanguageStrings().AssetConfigurationStrings.components.warnings

export const ParameterWarning = (): JSX.Element => {
  return (
    <div style={{ display: 'flex', backgroundColor: '#404040', margin: '2em', padding: '0.005em 1em calc(0.005em + 20px) 3em', alignItems: 'flex-end', borderRadius: '10px' }}>
      <img src={warningParam} />
      <h3 style={{ color: 'white', paddingRight: '4px', paddingLeft: '20px', paddingBottom: '6px' }}>{WarningString.PLEASE_ADD_PARAMETERS}</h3>
    </div>
  )
}

interface CautionWarningProps {
  heading: string
  messages: string[]
}

export const CautionWarning = (props: CautionWarningProps): JSX.Element => {
  return (
    <div style={{ display: 'flex', backgroundColor: '#404040', padding: '2em', alignItems: 'flex-end', borderRadius: '10px', width: 'fit-content' }}>
      <img src={selectCaution} />
      <div style={{ margin: '3em' }}>
        <Typography sx={{ fontFamily: 'Honeywell Sans Web', fontSize: '16px', fontWeight: '800', lineHeight: '24px', letterSpacing: '2.5px', marginBottom: '20px' }}>
          {props.heading}
        </Typography>
        <Typography sx={{ fontFamily: 'Honeywell Sans Web', fontSize: '16px', fontWeight: '500', lineHeight: '24px' }}>
          {WarningString.This_could_be_because}
        </Typography>
        <ul>
          {props.messages.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </ul>
      </div>
    </div>
  )
}
